<template>
  <div class="login-container">
    <div class="store-title">店铺名称：{{ activityInfo.customerName }}</div>
    <van-field v-model="authorizationCode" label="" placeholder="授权码" />
    <van-button type="warning" class="login-btn" @click="submitLogin">Login</van-button>
  </div>
</template>

<script>
import { appLoginApi, activityInfoApi } from '@/api'
import { Toast } from 'vant'
import { mapMutations } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      authorizationCode: '',
      customerKey: '',
      activityInfo: {}
    }
  },
  created() {
    // https://voopoo-test.oss-cn-shenzhen.aliyuncs.com?customerKey=111111
    // 当前页面的 URL
    const url = window.location.href; // 或直接使用完整URL
    const urlObj = new URL('https://voopoo-test.oss-cn-shenzhen.aliyuncs.com?customerKey=111111');
    const params = new URLSearchParams(urlObj.search);

    // 获取特定参数的值
    this.customerKey = params.get('customerKey'); // 返回 'sada'
    this.getActivityInfo()
    // // 获取所有参数
    // for (const [key, value] of params.entries()) {
    //     console.log(key, value); // 输出: dsad sada
    // }
  },
  methods: {
    ...mapMutations(['setToken', 'setUSERINFO', 'setActivityInfo']),
    submitLogin() {
      if (!this.authorizationCode) {
        Toast('请输入授权码')
        return
      }
      const data = {
        customerKey: this.customerKey,
        code: this.authorizationCode
      }
      Toast.loading({
				message: 'loading...',
				forbidClick: true,
				duration: 0
			})
      appLoginApi(data).then(res => {
        Toast.clear()
        const { token, user } = res.data
        this.setToken(token)
        this.setUSERINFO({ ...user, customerKey: this.customerKey })
        this.$router.push('/activity')
      }).catch(err => {
        // Toast.clear()
      })
    },
    getActivityInfo() {
      Toast.loading({
				message: 'loading...',
				forbidClick: true,
				duration: 0
			})
      activityInfoApi(this.customerKey).then(res => {
        Toast.clear()
        this.activityInfo = res.data || {}
        this.setActivityInfo(this.activityInfo)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  background: #fff;
  position: relative;
  padding: 130px 20px 0;
  box-sizing: border-box;
  .store-title {
    font-size: 16px;
    font-weight: 600;
  }
  /deep/.van-field {
    padding: 5px 10px;
    margin-top: 10px;
    margin-bottom: 30px;
    border: 1px solid #dce5f6;;
    border-radius: 10px;
  }
  .login-btn {
    width: 100%;
    background-color: #ee541b;
    border-radius: 16px;
  }
}
</style>
